<template>
  <label class="font-weight-bold caption">
    <input
      onclick="return false;"
      type="checkbox"
      :checked="checked"
      style="pointer-events: none;"
    />
    {{ label }}
  </label>
</template>

<script>
export default {
  name: 'DisplayCheckbox',
  computed: {
    checked() {
      if (typeof this.inputValue === 'boolean') {
        return this.inputValue;
      }
      return this.inputValue === 'O';
    },
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    inputValue: {
      default: false,
    },
  },
};
</script>
